import React, { useEffect } from 'react'
import { api } from 'components/api'
import { pageEventsPath } from '../routes/path'

interface CategoryAdProps {
  ad: {
    displayAd: boolean
    id: number
    clickUrl: string
    fullImageUrl: string
    mobileImageUrl: string
    linkClickToken: string
  } | null
  variant?: 'desktop' | 'mobile'
  shouldTrackView?: boolean
}

export function CategoryAd ({ ad, variant = 'desktop', shouldTrackView = true }: CategoryAdProps): JSX.Element | null {
  useEffect(() => {
    if (ad?.displayAd === true && shouldTrackView) {
      void postPageEvent('page_view')
    }
  }, [ad, shouldTrackView])

  const postPageEvent = (eventType: 'page_view' | 'ad_unit_click'): void => {
    if (ad == null) return

    void api.postWithCsrf({
      url: pageEventsPath(),
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      params: {
        token: ad.linkClickToken,
        event_type: eventType,
        host: window.location.host,
        pathname: window.location.pathname,
        query_parameters: window.location.search
      }
    })
  }

  const handleClick = (): void => {
    postPageEvent('ad_unit_click')
  }

  if ((ad == null) || !(ad?.displayAd)) return null

  const imageUrl = variant === 'mobile' ? ad?.mobileImageUrl : ad?.fullImageUrl

  return (
    <a
      href={ad.clickUrl}
      onClick={handleClick}
      target='_blank'
      rel='noopener noreferrer'
      className='banner-link'
    >
      <div className='banner' id={`banner-${ad.id}`} data-testid='banner-container'>
        <img src={imageUrl} alt='' />
      </div>
    </a>
  )
}
